import * as yup from 'yup';

export const validationSchema = yup
  .object({
    alias: yup.string().min(3, 'Screen Name must be at least 3 characters').required('Screen Name is required'),
    lastName: yup.string().min(2, 'The last must be at least 2 characters').required('Last name is required'),
    firstName: yup.string().min(2, 'A first name must be at least 2 characters').required('First name is required'),
    phone: yup
      .number()
      .transform((value, originalValue) => {
        return originalValue === '' ? null : value;
      })
      .optional(),
    //.required("A phone number is required"),
    phoneCode: yup.string().required('A phone code is required'),
    referralCode: yup.string().optional(),
  })
  .required();
